import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMegaphone20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconMegaphone20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14.5 3.747a.25.25 0 0 0-.38-.214L10.237 5.89l-.18.109H9v4.5h1.062l.182.113 3.874 2.413a.25.25 0 0 0 .382-.212zM9.637 4.5H3.5A2.5 2.5 0 0 0 1 7v2.5c0 .89.465 1.671 1.165 2.114l1.167 5.4A1.25 1.25 0 0 0 4.554 18H6.25c.69 0 1.25-.56 1.25-1.25V12h2.133l3.692 2.3c1.166.725 2.675-.113 2.675-1.486V3.747c0-1.365-1.492-2.204-2.658-1.496zM3.5 6h4v4.5h-4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1m.283 6 .972 4.5H6V12zm15.292-5.873a.75.75 0 0 0-1.5 0v4.653a.75.75 0 0 0 1.5 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMegaphone20);
